import { TEXT_FIELD } from '../type_name'
const defaultHandler = header => header
const handers_hash = {}
const components_hash = {}
const context = require.context('./', true, /\.jsx$/);

const proxy_fun = (source, default_field = TEXT_FIELD, text) => new Proxy(source, {
    get(target, type_key) {
        if (type_key === 'undefined') {
            return target[default_field]
        }
      if (!target[type_key]) {
         console.error(`暂无${type_key}${text}`);  
      } else {
          return target[type_key]
      }
    }
})

 context.keys().map((path) => {
    if (path === './index.js') {
        return 
    }
    const target = context(path)
    const obj = target.default
    const headerHandler = target.headerHandler || defaultHandler
    if (components_hash[obj.name]) {
        console.error('table组件的name必须唯一');  
    }
    components_hash[obj.name] = obj
    handers_hash[obj.name] = headerHandler
})
export const handlers = proxy_fun(handers_hash, TEXT_FIELD, '类型组件的表头处理，如需要可自行注册')
export const components = proxy_fun(components_hash, TEXT_FIELD, '类型的组件，如需要可自行注册')